import { ILanguage } from "types";

export const articleCategories = [
  {
    name: "work",
    colors: {
      bg: "#D1E6F4",
      text: "#008FFF",
    },
  },
  {
    name: "health",
    colors: {
      bg: "#D1E6F4",
      text: "#3376FD",
    },
  },
  {
    name: "administration",
    colors: {
      bg: "#D1E6F4",
      text: "#3376FD",
    },
  },
  {
    name: "education",
    colors: {
      bg: "#D1E6F4",
      text: "#3376FD",
    },
  },
  {
    name: "children",
    colors: {
      bg: "#CDCECE",
      text: "#000000",
    },
  },
  {
    name: "accommodation",
    colors: {
      bg: "#FDDD00",
      text: "#000000",
    },
  },
  {
    name: "legalSupport",
    colors: {
      bg: "#CDF2EC",
      text: "#00BF9B",
    },
  },
  {
    name: "activities",
    colors: {
      bg: "#f2cdcd",
      text: "#bf0000",
    },
  },
  {
    name: "news",
    colors: {
      bg: "#FDDD00",
      text: "#000000",
    },
  },
  {
    name: "other",
    colors: {
      bg: "#CDF2EC",
      text: "#00BF9B",
    },
  },
];

export const articleStatuses = [
  {
    name: "draft",
    color: "#FA6400",
  },
  {
    name: "to-validate",
    color: "#E02020",
  },
  {
    name: "published",
    color: "#00BF9B",
  },
  {
    name: "refused",
    color: "#FAC809",
  },
  {
    name: "archived",
    color: "#7b7a7d",
  },
];

export const translationStatuses = [
  {
    name: "auto-generated",
    color: "#FAC809",
  },
  {
    name: "translated",
    color: "#D0E83E",
  },
  {
    name: "not-translated",
    color: "#F2451F",
  },
];

export const languages: ILanguage[] = [
  { name: "en", title: "English", translatedTitle: "English" },
  { name: "ar", title: "Arabic", translatedTitle: "عربي" },
  { name: "fr", title: "French", translatedTitle: "Français" },
  { name: "ta", title: "Tamil", translatedTitle: "தமிழ்" },
  { name: "ti", title: "Tigrinya", translatedTitle: "ትግርኛ" },
  { name: "tr", title: "Turkish", translatedTitle: "Türkçe" },
  { name: "uk", title: "Ukrainian", translatedTitle: "Українська" },
  { name: "fa", title: "Farsi", translatedTitle: "فارسی" },
  { name: "ru", title: "Russian", translatedTitle: "русский" },
  { name: "es", title: "Spanish", translatedTitle: "Castellano" },
  { name: "mn", title: "Mongolian", translatedTitle: "монгол" },
  { name: "fil", title: "Filipino", translatedTitle: "Filipino" },
  { name: "pt", title: "Portuguese", translatedTitle: "Português" },
];

export const someTranslations = {
  preferredLanguage: {
    en: "Preferred language",
    ar: "اللغة المفضلة",
    es: "Idioma elegido",
    fr: "Langue préférée",
    pt: "Língua preferida",
    ta: "விருப்பமான மொழி",
    ti: "ትመርጽዎ ቋንቋ",
    tr: "Tercih edilen dil",
    uk: "Бажана мова",
    fa: "زبان ترجیحی",
    ru: "Предпочитаемый язык",
    mn: "Сонирхож буй хэл",
    fil: "Gustong lenggwahe",
  },
  confirm: {
    en: "Confirm",
    ar: "تأكيد",
    es: "Confirmar",
    fr: "Confirmer",
    pt: "confirmar",
    ta: "உறுதிப்படுத்து",
    ti: "የረጋግጽ/ሕራይ",
    tr: "Onayla",
    uk: "Підтвердити",
    fa: "تائید",
    ru: "Подтвердить",
    mn: "Батлах",
    fil: "Sang-ayon",
  },
};
